import { fetchMessagesFromCDN } from '@cbhq/intl';

import { convertLocale, noop } from '../../utils';

export const SMARTLING_PROJ_ID_PROD = 'a4ccd4c0f';
// export const SMARTLING_PROJ_ID_DEV = '8528db726'; Not used cause translations are too out of date

export async function getI18nMessages(
  locale: string,
  isProd = true,
  serviceIdentifier?: string,
  smartlingProjectId: string = SMARTLING_PROJ_ID_PROD,
): Promise<Record<string, string>> {
  noop(isProd); // Avoiding to remove isProd and make this function backwads incompatible
  const convertedLocale = convertLocale(locale);
  const messages = await fetchMessagesFromCDN(
    convertedLocale,
    smartlingProjectId,
    serviceIdentifier,
    {
      env: 'production',
    },
  );

  return messages;
}
